import { DisplayPosition } from '@/type/display-position';
import { getDatePrecisionSetterSnippet } from '@/common/manager/setter-snippet';
// import {
//   CnDatePickerPro,
//   componentMap as formComponentMap,
// } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '日期选择',
    componentName: 'CnDatePickerPro',
    // component: CnDatePickerPro,
    // formComponent: formComponentMap.CnDatePickerPro,
    getDefaultProps: () => {
        return {
            precision: 'day',
        };
    },
    getPrototypeList: () => {
        return [
            getDatePrecisionSetterSnippet(),
            {
                name: 'outputFormat',
                title: '输出格式',
                display: 'inline',
                setter: {
                    componentName: 'SelectSetter',
                    props: {
                        options: [
                            {
                                label: '时间戳',
                                value: '',
                            },
                            {
                                label: 'YYYY',
                                value: 'YYYY',
                            },
                            {
                                label: 'YYYY-MM',
                                value: 'YYYY-MM',
                            },
                            {
                                label: 'YYYY-MM-DD',
                                value: 'YYYY-MM-DD',
                            },
                            {
                                label: 'YYYY-MM-DD HH',
                                value: 'YYYY-MM-DD HH',
                            },
                            {
                                label: 'YYYY-MM-DD HH:mm',
                                value: 'YYYY-MM-DD HH:mm',
                            },
                            {
                                label: 'YYYY-MM-DD HH:mm:ss',
                                value: 'YYYY-MM-DD HH:mm:ss',
                            },
                        ],
                    },
                },
            },
            // {
            //   name: 'showTime',
            //   title: '显示时间',
            //   display: 'inline',
            //   setter: 'BoolSetter',
            //   // condition(prop) {
            //   //   return condition(prop, 'DatePicker', 'componentName') && prop?.parent?.getPropValue?.('type') === 'date';
            //   // },
            // },
        ];
    },
};
